export enum DatabaseIndexNameType {
    abandonedMines = 'abandoned-mine',
    assessment = 'assessment',
    drillHoles = 'drill-hole',
    mineralInventory = 'mineral-inventory',
    publication = 'publication',
    assessment_pdf = "assessment-pdf",
    publication_pdf = "publication-pdf"
}